import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { HXButton } from "./HXButton";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
import { LightText } from "./HXDesktopPage.styles";
export const LoginFields = styled(FlexColumnDiv) `
    margin-top: 16px;
    align-self: stretch;
    gap: 16px;
`;
export const LoginFormItem = styled.label `
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & ${HXTextField} {
        width: 100%;
    }
`;
export const LoginErrorMessage = styled.div `
    color: red;
    font-size: 16px;
`;
export const ForgotPasswordButton = styled(HXButton) `
    padding: 6px 0px;
`;
export const MobileDisclaimer = styled(LightText) `
    font-size: ${fontSizes.TINY};
    text-align: center;
`;
